import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=8362d742&scoped=true&lang=scss"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/1fe6d5c2-02f8-4b7b-a7ed-3827401bba29/workspace/toilet-go-front_Ak2Q/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8362d742"]])

export default __exports__